import React from 'react';
import { ChevronDown } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background with gradient overlay */}
      <div className="absolute inset-0 bg-[#0a0a0a]">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a] via-transparent to-[#0a0a0a] opacity-90" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(193,165,79,0.08)_0%,_transparent_70%)]" />
      </div>

      {/* Decorative elements */}
      <div className="absolute top-1/4 left-10 w-px h-32 bg-gradient-to-b from-transparent via-[#C1A54F]/30 to-transparent" />
      <div className="absolute top-1/3 right-10 w-px h-40 bg-gradient-to-b from-transparent via-[#E5B1C4]/30 to-transparent" />
      <div className="absolute bottom-1/4 left-1/4 w-32 h-px bg-gradient-to-r from-transparent via-[#C1A54F]/20 to-transparent" />
      <div className="absolute top-1/4 right-1/4 w-40 h-px bg-gradient-to-r from-transparent via-[#E5B1C4]/20 to-transparent" />

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto pt-20">
        {/* Decorative line */}
        <div className="flex items-center justify-center mb-8 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
          <div className="w-16 h-px bg-gradient-to-r from-transparent to-[#C1A54F]" />
          <span className="mx-4 text-[#E1C57C] text-xs tracking-[0.3em]">✦</span>
          <div className="w-16 h-px bg-gradient-to-l from-transparent to-[#C1A54F]" />
        </div>

        {/* Tagline */}
        <p className="font-display text-xl sm:text-2xl md:text-3xl text-[#E5B1C4] mb-4 tracking-wide animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
          Beleza & Tratamento Corporal
        </p>

        {/* Description */}
        <p className="text-[#bbb5ae] text-base sm:text-lg max-w-2xl mx-auto mb-12 leading-relaxed animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
          Descubra a sua melhor versão com os nossos tratamentos exclusivos de depilação a laser, 
          tratamentos corporais avançados e produtos de beleza premium.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up" style={{ animationDelay: '0.5s' }}>
          <Button
            onClick={(e) => scrollToSection(e, '#marcacoes')}
            className="btn-gold px-10 py-4 rounded-none font-medium tracking-widest text-sm pulse-gold"
          >
            MARCAR SESSÃO
          </Button>
          <Button
            onClick={(e) => scrollToSection(e, '#servicos')}
            variant="outline"
            className="btn-outline-gold px-10 py-4 rounded-none font-medium tracking-widest text-sm"
          >
            VER SERVIÇOS
          </Button>
        </div>

        {/* Services preview */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-8 animate-fade-in-up" style={{ animationDelay: '0.6s' }}>
          {['Depilação a Laser', 'Lipozero', 'Pressoterapia', 'Mary Kay'].map((service, index) => (
            <div key={index} className="text-center group cursor-pointer" onClick={(e) => scrollToSection(e, '#servicos')}>
              <div className="w-12 h-12 mx-auto mb-3 rounded-full border border-[#C1A54F]/30 flex items-center justify-center group-hover:border-[#C1A54F] group-hover:bg-[#C1A54F]/10 transition-all duration-300">
                <span className="text-[#E1C57C] text-lg">✦</span>
              </div>
              <span className="text-[#f5f0e8] text-xs sm:text-sm tracking-wide group-hover:text-[#E1C57C] transition-colors">
                {service}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <a href="#servicos" onClick={(e) => scrollToSection(e, '#servicos')} className="text-[#C1A54F]/50 hover:text-[#C1A54F] transition-colors">
          <ChevronDown size={32} />
        </a>
      </div>
    </section>
  );
};

export default Hero;
